import { FC, ReactNode, useMemo } from 'react';
import { Role } from 'src/apis/monolith/types';
import { useAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';
import { Forbidden } from 'src/utils/errors';

export const RoleGateway: FC<{ allowed: Role[]; children: ReactNode }> = ({
  children,
  allowed,
}) => {
  const monolithUser = useAuthenticatedMonolithUser();
  const hasValidRole = useMemo(
    () => allowed.some((role) => role === monolithUser.role),
    [allowed, monolithUser.role]
  );

  if (hasValidRole) {
    return <>{children}</>;
  } else {
    throw new Forbidden();
  }
};
